import JobCandidatesPage from './JobCandidates.container';

export default JobCandidatesPage;
